/* ==========================================================================
   Recently viewed — Sept 2026
   Remembers the last products a shopper looked at (product pages and quick views) in localStorage and
   renders them into any [data-recent] host: "grid" (product page, cart page — full product cards in a
   slider) or "drawer" (cart drawer — compact tiles). Cards come from /products/<handle>?view=card
   (templates/product.card.liquid), so they match the collection grid exactly.
   ========================================================================== */
var TCPRecent = (function () {
  var KEY = 'tcp_recent', MAX = 12;
  var cache = {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function read() { try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} }

  function record(handle, color) {
    if (!handle) return;
    var list = read().filter(function (i) { return i.h !== handle; });
    list.unshift({ h: handle, c: color || '', t: Date.now() });
    write(list);
  }

  /* One card per product, cached for the page lifetime. Resolves to null when the product is gone. */
  function fetchCard(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.product');
          return card ? card.outerHTML : null;
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function productId(card) { var m = card.innerHTML.match(/image-group-(\d+)/); return m ? m[1] : null; }

  /* Show the colorway the shopper actually looked at. */
  function activateColor(card, color) {
    if (!color) return;
    var groups = $$('.image-group', card), hit = null;
    groups.forEach(function (g) {
      Array.prototype.forEach.call(g.classList, function (c) { var m = c.match(/^image-group-\d+-(.+)$/); if (m && m[1] === color) hit = g; });
    });
    if (!hit) return;
    groups.forEach(function (g) { g.classList.toggle('active', g === hit); });
    var a = $('a', hit); if (a && a.href.indexOf('color=') < 0) a.href += (a.href.indexOf('?') < 0 ? '?' : '&') + 'color=' + color;
    var titleLink = $('.product > div > p > a', card); if (titleLink && titleLink.href.indexOf('color=') < 0) titleLink.href += (titleLink.href.indexOf('?') < 0 ? '?' : '&') + 'color=' + color;
  }

  function miniTile(card) {
    var group = $('.image-group.active', card) || $('.image-group', card);
    var img = group ? ($('img.d-none.d-md-block:not(.hover)', group) || $('img', group)) : null;
    var link = $('.product > div > p > a', card);
    var priceEl = $('.product > div .d-flex > p', card);
    if (!img || !link) return '';
    var title = (link.textContent || '').trim().split(' - ')[0];
    var price = priceEl ? (priceEl.firstChild && priceEl.firstChild.textContent || priceEl.textContent).trim() : '';
    return '<a class="tcp-rec" href="' + link.getAttribute('href') + '">' +
      '<span class="tcp-rec__img"><img src="' + img.getAttribute('src') + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy"></span>' +
      '<span class="tcp-rec__title">' + title + '</span>' +
      (price ? '<span class="tcp-rec__price">' + price + '</span>' : '') + '</a>';
  }

  function render(host) {
    if (host.getAttribute('data-ready') === '1') return;
    host.setAttribute('data-ready', '1');
    var mode = host.getAttribute('data-recent') || 'grid';
    var limit = parseInt(host.getAttribute('data-limit'), 10) || (mode === 'drawer' ? 4 : 8);
    var exclude = (host.getAttribute('data-exclude') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    // Cart drawer and cart page: skip anything already in the bag. (The product page keeps them — the drawer lines are in the DOM there too.)
    var skipInCart = mode === 'drawer' || document.body.classList.contains('template-cart');
    var inCart = skipInCart ? $$('.tcp-line[data-product-id]').map(function (l) { return l.getAttribute('data-product-id'); }) : [];
    var list = read().filter(function (i) { return exclude.indexOf(i.h) < 0; }).slice(0, limit + 4);
    if (!list.length) { host.hidden = true; return; }

    Promise.all(list.map(function (i) { return fetchCard(i.h).then(function (html) { return { item: i, html: html }; }); })).then(function (results) {
      var cards = [];
      results.forEach(function (r) {
        if (!r.html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = r.html;
        var card = tmp.firstElementChild;
        if (inCart.indexOf(productId(card)) >= 0) return;
        activateColor(card, r.item.c);
        cards.push(card);
      });
      cards = cards.slice(0, limit);
      if (cards.length < (mode === 'drawer' ? 2 : 1)) { host.hidden = true; return; }

      if (mode === 'drawer') {
        host.innerHTML = '<div class="tcp-recs tcp-recs--recent" data-count="' + cards.length + '"><h3 class="tcp-recs__title">Recently viewed</h3><div class="tcp-recs__row">' +
          cards.map(miniTile).join('') + '</div></div>';
        host.hidden = false;
        return;
      }

      // Product page: sit above "You May Also Like" (that section is rendered by product-template.liquid; the host lives in theme.liquid).
      if (document.body.classList.contains('template-product')) {
        var ymalH2 = $$('h2').filter(function (h) { return /You May/i.test(h.textContent); })[0];
        var ymal = ymalH2 && ymalH2.closest('.container-fluid');
        if (ymal && ymal.previousElementSibling !== host) ymal.parentNode.insertBefore(host, ymal);
      }
      host.innerHTML = '<h2>Recently <i>Viewed</i></h2>' +
        '<div class="related-products tcp-recent__swiper swiper"><div class="swiper-wrapper">' +
        cards.map(function (c) { return '<div class="swiper-slide">' + c.outerHTML + '</div>'; }).join('') +
        '</div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div>';
      host.hidden = false;
      if (typeof bindAddToCartForms === 'function') bindAddToCartForms();
      var el = $('.tcp-recent__swiper', host);
      if (window.Swiper && el) {
        new Swiper(el, {
          loop: false, slidesPerView: 2, spaceBetween: 15, watchOverflow: true, observer: true, observeParents: true,
          navigation: { nextEl: $('.swiper-button-next', el), prevEl: $('.swiper-button-prev', el) },
          breakpoints: { 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 } }
        });
      }
    });
  }

  function renderAll() { $$('[data-recent]').forEach(render); }

  /* Product page: note the product (and colorway) being viewed. */
  function recordPageView() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var color = new URLSearchParams(location.search).get('color') || '';
    if (!color) {
      var g = $('.product-images-group.active');
      if (g) Array.prototype.forEach.call(g.classList, function (c) { var mm = c.match(/^product-images-group-(.+)$/); if (mm) color = mm[1]; });
    }
    record(handle, color);
  }

  function bind() {
    recordPageView();
    renderAll();
    document.addEventListener('tcp:cart:rendered', renderAll);
    document.addEventListener('tcp:product:viewed', function (e) { if (e.detail) record(e.detail.handle, e.detail.color); });
  }

  return { record: record, render: render, renderAll: renderAll, bind: bind, list: read };
})();

if (document.readyState === 'complete') TCPRecent.bind(); else window.addEventListener('load', function () { TCPRecent.bind(); });
